<template>
    <div>
        <span class="p-input-icon-left w-full">
            <i class="pi pi-envelope"></i>
            <input-text
                id="email"
                ref="emailInputRef"
                v-bind="fieldBind"
                inputmode="email"
                type="email"
                class="w-full !text-[16px]"
                :class="{
                    'border border-danger-200': error !== undefined
                }"
                :placeholder="t('customerInformation.emailAddress')"
                aria-describedby="email-error"
                :disabled="disabled"
            />
        </span>
        <span
            v-if="error"
            id="email-error"
            class="text-small text-red-600"
            >{{ error }}</span
        >
    </div>
</template>

<script setup lang="ts">
import InputText from 'primevue/inputtext'
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

defineProps<{
    disabled: boolean
    error: string | undefined
    fieldBind: Record<string, unknown>
}>()

const { t } = useI18n()
const emailInputRef = ref<{ $el?: HTMLElement | HTMLInputElement } | null>(null)

function focus() {
    const inputTextComponent = emailInputRef.value as unknown

    if (inputTextComponent instanceof HTMLInputElement) {
        inputTextComponent.focus()
        return
    }

    const element = (
        inputTextComponent as { $el?: HTMLElement | HTMLInputElement } | null
    )?.$el

    if (element instanceof HTMLInputElement) {
        element.focus()
        return
    }

    element?.querySelector<HTMLInputElement>('input')?.focus()
}

defineExpose({ focus })
</script>
